import styled from '@emotion/styled'

export default styled('main')`
  max-width: 980px;
  margin: 0 auto;
`
